export const BaseUrl = "https://api.doxandbox.com/";
